<div class="divHeader">
    <mat-icon class="btnCancelTest" (click)="closeModal()">close</mat-icon>
</div>

<div class="divBody">

    <p><strong>Olá, colaboradores!</strong><br>
    Para que o pagamento das notas fiscais aconteça sem atrasos, é importante ficar atento aos prazos de envio dos documentos.</p>
    
    <p>Essas datas ajudam o time a analisar, registrar e se organizar conforme o calendário financeiro, <br> 
    garantindo que o pagamento siga o processo de forma adequada.<br>
    Para facilitar o planejamento ao longo do ano, disponibilizamos o <strong>calendário com as datas-limite de envio.</strong></p>
    
    <p><strong>Importante: quando as notas são enviadas após o prazo, isso pode atrapalhar o fluxo financeiro e impactar o pagamento.</strong> </p>
</div>

<div class="divFooter">

    <p>Confira o calendário abaixo e, se tiver dúvidas, fale com o time de <strong>Contas a Pagar</strong>.</p>

    <img class="imgFooter" src="assets/images/imagemModalAvisosNotaFiscal.png" alt="Calendário de datas limite">
</div>
